// extracted by mini-css-extract-plugin
module.exports = {"posts_grid":"styles_posts_grid__DzE8Z"};